import { useMemo } from 'react'

import { useOOMenus } from 'public/components/online_ordering/useOOMenu'
import { ScreenWidth, useIsMobile } from 'src/shared/js/utils/WindowContext'

export const useVariableMenuSpacing = (): boolean => {
  const isMobile = useIsMobile(ScreenWidth.EXTRA_SMALL)
  const { menuItems, menus, products } = useOOMenus({})

  const hasMenuImages = useMemo(() => {
    // Use menuItems when non-empty; fall back to menus tree for non-paginated
    // restaurants where menuItems is undefined or [] but items live in menus.
    const allItems = menuItems?.length
      ? menuItems
      : menus?.flatMap(
          (menu) => menu.groups?.flatMap((group) => group?.items ?? []) ?? []
        )

    return (
      !!allItems?.some(
        (item) =>
          item?.imageUrls != null && Object.keys(item.imageUrls).length > 0
      ) ||
      !!products?.some(
        (product) =>
          product?.imageLink ||
          (product?.imageUrls != null &&
            Object.keys(product.imageUrls).length > 0)
      )
    )
  }, [menuItems, menus, products])

  return isMobile && !hasMenuImages
}
